import React, { useCallback, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { RMSSelect } from '../../../shared/components/form-controls';
import SearchPersonAutoComplete from '../../../shared/components/modules/SearchPersonAutoComplete';
import SearchPlaceAutoComplete from '../../../shared/components/modules/SearchPlaceAutoComplete';
import AddPersonDialog from './AddPersonDialog';
import AddPlaceDialog from './AddPlaceDialog';
import {
  PARTY_KIND,
  PARTY_KIND_OPTIONS,
  PARTY_KIND_SELECT_PROPS,
} from '../../constants/partyKindLookupConstants';

const PartyKindLookup = ({ typeFieldName, idFieldName, typeLabel, idLabel, idValue }) => {
  const { control, setValue } = useFormContext();
  const [addPersonDialogOpen, setAddPersonDialogOpen] = useState(false);
  const [addPlaceDialogOpen, setAddPlaceDialogOpen] = useState(false);
  const partyKind = useWatch({ control, name: typeFieldName });

  const handlePersonCreated = useCallback(
    (person) => {
      setValue(idFieldName, person?.ptsPersonID ?? null, {
        shouldDirty: true,
        shouldValidate: true,
      });
      setAddPersonDialogOpen(false);
    },
    [idFieldName, setValue]
  );

  const handlePlaceCreated = useCallback(
    (ptsPlaceID) => {
      setValue(idFieldName, ptsPlaceID ?? null, {
        shouldDirty: true,
        shouldValidate: true,
      });
      setAddPlaceDialogOpen(false);
    },
    [idFieldName, setValue]
  );

  return (
    <>
      <Grid item xs={6}>
        <RMSSelect
          name={typeFieldName}
          label={typeLabel}
          options={PARTY_KIND_OPTIONS}
          {...PARTY_KIND_SELECT_PROPS}
          onChange={() => setValue(idFieldName, null)}
        />
      </Grid>
      <Grid item xs={6}>
        {partyKind === PARTY_KIND.PLACE && (
          <SearchPlaceAutoComplete
            name={idFieldName}
            label={idLabel}
            defaultPlaceId={idValue}
            onAddIconClick={() => setAddPlaceDialogOpen(true)}
            showDetailsIcon={false}
          />
        )}
        {partyKind === PARTY_KIND.PERSON && (
          <SearchPersonAutoComplete
            name={idFieldName}
            label={idLabel}
            defaultPersonId={idValue}
            onAddIconClick={() => setAddPersonDialogOpen(true)}
            showDetailsIcon={false}
          />
        )}
      </Grid>

      {addPersonDialogOpen && (
        <AddPersonDialog
          open={addPersonDialogOpen}
          onClose={() => setAddPersonDialogOpen(false)}
          onPersonCreated={handlePersonCreated}
        />
      )}

      {addPlaceDialogOpen && (
        <AddPlaceDialog
          open={addPlaceDialogOpen}
          onClose={() => setAddPlaceDialogOpen(false)}
          onPlaceCreated={handlePlaceCreated}
        />
      )}
    </>
  );
};

export default PartyKindLookup;
